import { CHANGE_LOCAL_STATE } from '../../constants';

export function changeLocalState(value: any) {
  document.dispatchEvent(new CustomEvent(CHANGE_LOCAL_STATE, { detail: { ...value } }));
}
